import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

import { CurrentScreen } from "./ui/screens/CurrentScreen";
import { ModelViewer } from "./viewer/ModelViewer/ModelViewer";
import { AllPiecesView } from "./viewer/scene/all-pieces/AllPiecesView";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <CurrentScreen />
  },
  {
    path: "/model-viewer",
    element: <ModelViewer />
  },
  {
    path: "/all-pieces",
    element: <AllPiecesView />
  }
]);

export function AppRoutes() {
  return <RouterProvider router={router} />;
}
